import type { AxiosInstance } from 'axios';
import type { PaginatedResponse } from '@/types/common.ts';
import type { SuiteSummary } from '@/types/automationSuites.ts';

/** PUT is also an edit: verify that an "add" cannot overwrite a hidden page's member.
 * The original Suite fence still protects admission after this observation.
 */
export async function assertNewSuiteMembership(
  api: AxiosInstance,
  automationId: string,
  suiteId: string,
  signal?: AbortSignal,
) {
  let page = 1;
  const visited = new Set<number>();
  for (let reads = 0; reads < 20; reads++) {
    signal?.throwIfAborted();
    if (visited.has(page)) break;
    visited.add(page);
    const { data } = await api.get<PaginatedResponse<SuiteSummary>>(
      `/automations/${automationId}/automation-suites`,
      { params: { page, page_size: 50 }, signal },
    );
    signal?.throwIfAborted();
    if (data.results.some((suite) => suite.id === suiteId)) {
      throw new Error('This automation is already a member. Edit its existing membership instead.');
    }
    if (!data.next) return;
    page = data.next.page;
  }
  throw new Error('Membership discovery is incomplete. No member was added.');
}
